document.addEventListener('DOMContentLoaded', function () {
  const personalizarRadio = document.querySelector('input[value="Personalizar"]');
  const naoPersonalizarRadio = document.querySelector('input[value="Não Personalizar"]');

  // Cria o bloco estilizado de inputs
  const campoPersonalizacao = document.createElement('div');
  campoPersonalizacao.id = 'campos-personalizar';
  campoPersonalizacao.style.display = 'none'; // escondido inicialmente

  campoPersonalizacao.innerHTML = `
    <div class="personalizar-box">
      <div class="personalizar-group">
        <label class="personalizar-label" for="nome-camisa">
          <strong>NOME</strong> <span>(ATÉ 15 CARACTERES)</span>
        </label>
        <input type="text" maxlength="15" name="properties[Nome]" id="nome-camisa" placeholder="Ex: João da Silva" />
      </div>
      <div class="personalizar-group">
        <label class="personalizar-label" for="numero-camisa">
          <strong>NÚMERO</strong> <span>(MÁXIMO 3 CARACTERES)</span>
        </label>
        <input type="text" maxlength="3" name="properties[Número]" id="numero-camisa" placeholder="Ex: 10" />
        <div class="preco-info" style="gap: 5px; margin-top: 5px;">
          <span class="preco-antigo1" style="text-decoration: line-through; color: #b12424; margin-right: 2px; font-size: 14px;"> R$49,99</span>
          <span class="preco-gratis">R$29,99</span>
        </div>
      </div>
    </div>
  `;

  // Adiciona dentro do form, antes do botão "Adicionar ao carrinho"
  const form = document.querySelector('form[action="/cart/add"]');
  const addToCartButton = form.querySelector('[data-add-to-cart]');
  form.insertBefore(campoPersonalizacao, addToCartButton);

  // Lógica de exibição
  function toggleCampos() {
    if (personalizarRadio && personalizarRadio.checked) {
      campoPersonalizacao.style.display = 'block';
    } else {
      campoPersonalizacao.style.display = 'none';
    }
  }

  personalizarRadio?.addEventListener('change', toggleCampos);
  naoPersonalizarRadio?.addEventListener('change', toggleCampos);

  toggleCampos(); // Inicializa corretamente no carregamento

  // Cria e adiciona o <style> com as animações no <head>
  const estiloPromo = document.createElement('style');
  estiloPromo.innerHTML = `
    .promo-msg {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #b12424;
      margin-top: 15px;
      margin-bottom: 15px;
    }

    .promo-msg .pulse-dot {
      width: 8px;
      height: 8px;
      background-color: #b12424;
      border-radius: 50%;
      margin-right: 12px;
      position: relative;
    }

    .promo-msg .pulse-dot::after {
      content: "";
      position: absolute;
      top: -3px;
      left: -3px;
      width: 14px;
      height: 14px;
      background-color: rgba(161, 36, 22, 0.3);
      border-radius: 50%;
      animation: pulse 1.2s ease-out infinite;
    }

    @keyframes pulse {
      0% {
        transform: scale(0.9);
        opacity: 1;
      }
      100% {
        transform: scale(1.6);
        opacity: 0;
      }
    }
  `;
  document.head.appendChild(estiloPromo);

  // Cria o bloco da mensagem promocional
  const promoMsg = document.createElement('div');
  promoMsg.className = 'promo-msg';
  promoMsg.innerHTML = `
    <div class="pulse-dot"></div>
    Últimas unidades restantes em promoção
  `;

  // Insere acima do botão "Adicionar ao carrinho"
  if (form && addToCartButton) {
    form.insertBefore(promoMsg, addToCartButton);
  }
});
